// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 143 ? "app" : chunkId) + "." + {"143":"b04b1847eeb2136ec959","511":"af3b8701fa7b912bd384"}[chunkId] + ".css";
};